import * as React from 'react';
import styled from 'styled-components';

import { getColor } from '@process-advisor/process-miner/shared/theme';

const Icon = styled.div`
    width: 0;
    height: 0;
    border-top: 7px solid ${getColor('black')};
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-radius: 5px;
`;

export const ExpandIcon = () => (
    <Icon />
);
